/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DiscountCouponShowResponse } from '../../models/discount-coupon-show-response';

export interface GetDiscountCouponShow$Params {
  camp: string;
  value: string;
}

export function getDiscountCouponShow(http: HttpClient, rootUrl: string, params: GetDiscountCouponShow$Params, context?: HttpContext): Observable<StrictHttpResponse<DiscountCouponShowResponse>> {
  const rb = new RequestBuilder(rootUrl, getDiscountCouponShow.PATH, 'get');
  if (params) {
    rb.path('camp', params.camp, {});
    rb.path('value', params.value, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DiscountCouponShowResponse>;
    })
  );
}

getDiscountCouponShow.PATH = '/v1/camp/{camp}/discount-coupon/{value}';
